import each from 'lodash/each'
import find from 'lodash/find'
import $ from 'jquery'
import Plyr from 'plyr'

function injectVideo($injector) {
  // Do not use $injector.data('sources'); Attr may be dynamically changed and .data() won't have new value.
  const sources = JSON.parse($injector.attr('data-sources') || null)
  if (Array.isArray(sources) && sources.length) {
    const baseSource = find(sources, { breakpointKey: 'base' })
    const injectBase = () => {
      $injector.html(baseSource ? (baseSource.embedCode || '') : '')
    }
    const mediaQueries = []
    const maybeFallback = () => {
      for (let i = 0; i < mediaQueries.length; i += 1) {
        if (mediaQueries[i].matches) {
          return
        }
      }
      injectBase()
    }
    for (let i = 0; i < sources.length; i += 1) {
      const source = sources[i]
      if (source.breakpoint) {
        const mq = window.matchMedia(source.breakpoint)
        const handleMqChange = (ev) => {
          if (ev.matches) {
            $injector.html(source.embedCode || '')
          } else {
            maybeFallback()
          }
        }
        mq.addEventListener('change', handleMqChange)
        handleMqChange(mq)
        mediaQueries.push(mq)
      } else {
        // Reached the 'base' breakpoint which has no media query
        maybeFallback()
      }
    }
    return
  }

  const isSmallOnly = $injector.hasClass('show-for-small')
  const isMediumUp = $injector.hasClass('show-for-medium')
  const isLargeUp = $injector.hasClass('show-for-large')
  const isXLargeUp = $injector.hasClass('show-for-xlarge')
  const isXXLargeUp = $injector.hasClass('show-for-xxlarge')

  const doInject = () => {
    const videoHtml = $injector.children('script').html()
    const $videoContainer = $injector.children('.video-container')
    if ($videoContainer.length) {
      $videoContainer.html(videoHtml)
      const $video = $videoContainer.find('video')
      if ($video.length && $video.data('src')) {
        $video.attr('src', $video.data('src')).removeAttr('data-src')
      }
      if (videoHtml.indexOf('data-plyr') !== -1) {
        const $plyrEl = $videoContainer.find('[data-plyr]')
        const opts = $plyrEl.data('plyr-options')
        new Plyr($plyrEl[0], opts || {})
      }
    }
  }

  const doUninject = () => {
    $injector.children('.video-container').html('')
  }

  function handleMediaQueryInject(mql) {
    if (mql.matches) {
      doInject()
    } else {
      doUninject()
    }
  }

  if (isSmallOnly) {
    window.APP.mq.small.addListener(handleMediaQueryInject)
    handleMediaQueryInject(window.APP.mq.small)
  } else if (isMediumUp) {
    window.APP.mq.medium.addListener(handleMediaQueryInject)
    handleMediaQueryInject(window.APP.mq.medium)
  } else if (isLargeUp) {
    window.APP.mq.large.addListener(handleMediaQueryInject)
    handleMediaQueryInject(window.APP.mq.large)
  } else if (isXLargeUp) {
    window.APP.mq.xlarge.addListener(handleMediaQueryInject)
    handleMediaQueryInject(window.APP.mq.xlarge)
  } else if (isXXLargeUp) {
    window.APP.mq.xxlarge.addListener(handleMediaQueryInject)
    handleMediaQueryInject(window.APP.mq.xxlarge)
  } else {
    doInject()
  }
}

/**
 * Destroy injected videos in the container.
 *
 * @param {HTMLElement} container
 */
function destroyVideos(container) {
  const $container = $(container)
  if (!$container.length) {
    return
  }

  $container.find('.js-video-injector').each((idx, injectorEl) => {
    const $injector = $(injectorEl)
    const sources = JSON.parse($injector.attr('data-sources'))
    if (Array.isArray(sources) && sources.length) {
      $(injectorEl).html('')
    } else {
      $(injectorEl).children('.video-container').html('')
    }
  })
}

/**
 * Inject videos in the container that are *not* in a modal.
 *
 * @param {HTMLElement} container
 * @param skipObserve If false, a MutationObserver is set up to watch for video injectors in the container.
 * @param ignoreModalAncestor Allows this method to be called where container is a modal element.
 */
function setupVideos(
  container,
  skipObserve = false,
  ignoreModalAncestor = false,
) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  const existingInjectors = container.querySelectorAll('.js-video-injector')
  if (existingInjectors.length) {
    each(existingInjectors, (injector) => {
      // Modals must call `setupVideos(modal, true, true)`
      if (injector.closest('.reveal') && !ignoreModalAncestor) {
        return
      }
      injectVideo($(injector))
    })
  }

  // Observe new elements:

  if (!skipObserve) {
    const observer = new MutationObserver((mutations) => {
      each(mutations, (mutation) => {
        each(mutation.addedNodes, (node) => {
          if (node.nodeType !== 1) {
            return
          }

          const injectors = node.querySelectorAll('.js-video-injector')
          if (!injectors.length) {
            return
          }

          each(injectors, (injector) => {
            // Modals must call `setupVideos(modal, true, true)`
            if (injector.closest('.reveal') && !ignoreModalAncestor) {
              return
            }
            injectVideo($(injector))
          })
        })
      })
    })

    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    })
  }
}

export { setupVideos, destroyVideos }
